module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "CPF",
      "field": "cpf",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14'),
      expression: "'required|min:14'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.cpf),
      expression: "dependenciaModal.dependente.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cpf",
      "id": "cpf",
      "data-vv-as": "CPF"
    },
    domProps: {
      "value": (_vm.dependenciaModal.dependente.cpf)
    },
    on: {
      "change": function($event) {
        return _vm.verificaCpf($event.target.value)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenciaModal.dependente, "cpf", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.telaEhMobile) ? _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.dataNascimento),
      expression: "dependenciaModal.dependente.dataNascimento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "dataNascimento",
      "id": "dataNascimento",
      "data-vv-as": "Data de Nascimento"
    },
    domProps: {
      "value": (_vm.dependenciaModal.dependente.dataNascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenciaModal.dependente, "dataNascimento", $event.target.value)
      }
    }
  })]) : _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Data de Nascimento",
      "field": "dataNascimento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataNascimento",
      "id": "dataNascimento",
      "config": _vm.config,
      "data-vv-as": "Data de Nascimento"
    },
    model: {
      value: (_vm.dependenciaModal.dependente.dataNascimento),
      callback: function($$v) {
        _vm.$set(_vm.dependenciaModal.dependente, "dataNascimento", $$v)
      },
      expression: "dependenciaModal.dependente.dataNascimento"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Nome",
      "field": "nome",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.nome),
      expression: "dependenciaModal.dependente.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "id": "nome",
      "autofocus": "autofocus",
      "data-vv-as": "Nome"
    },
    domProps: {
      "value": (_vm.dependenciaModal.dependente.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dependenciaModal.dependente, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Parentesco",
      "field": "parentesco",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.grau),
      expression: "dependenciaModal.grau"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parentesco",
      "data-vv-as": "Parentesco"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenciaModal, "grau", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.graus), function(grau) {
    return _c('option', {
      key: _vm.graus.indexOf(grau),
      domProps: {
        "value": grau.name
      }
    }, [_vm._v("\n                      " + _vm._s(_vm._f("tudoMaiusculo")(grau.displayName)) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Sexo",
      "field": "sexo",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependenciaModal.dependente.sexo),
      expression: "dependenciaModal.dependente.sexo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo",
      "id": "sexo",
      "data-vv-as": "Sexo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dependenciaModal.dependente, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.sexos), function(sexo) {
    return _c('option', {
      key: _vm.sexos.indexOf(sexo),
      domProps: {
        "value": sexo.name
      }
    }, [_vm._v("\n                      " + _vm._s(_vm._f("tudoMaiusculo")(sexo.displayName)) + "\n                    ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [(_vm.rendasOrdenadas.length === 0) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 form-group",
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('label', [_vm._v("Renda Anual")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-lg-6 col-md-6 col-sm-6 col-xs-4"
  }, [_c('label', [_vm._v("Ano Referência")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rendasOrdenadas[0].anoReferencia))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', [_vm._v("Renda Anual")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("monetarioMask")(_vm.rendasOrdenadas[0].valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-4",
    staticStyle: {
      "text-align": "right",
      "padding-top": "15px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-cinza-sm",
      "icone": "editar-tabela"
    },
    on: {
      "clicado": function($event) {
        return _vm.editaRenda(_vm.dependenciaModal)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.rendaEhAnoAtual),
      expression: "!rendaEhAnoAtual"
    }],
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("\n                      Se houver, cadastre a renda de\n                    " + _vm._s(_vm.anoReferenciaAtual) + ".\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row-field visible-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 footer-controller-inner-modal",
    staticStyle: {
      "margin-top": "-7px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Renda",
      "icone": "mais"
    },
    on: {
      "clicado": function($event) {
        return _vm.novaRenda()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner-modal hidden-xs",
    staticStyle: {
      "margin-top": "-7px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-dir",
      "rotulo": "Renda",
      "icone": "mais"
    },
    on: {
      "clicado": function($event) {
        return _vm.novaRenda()
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Salvar",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.valida()
      }
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: _vm.navs[1].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-field"
  }, [(_vm.anoEditavel) ? _c('field-validation', {
    attrs: {
      "css-class": "col-xs-7 col-sm-4",
      "label": "Ano Ref.",
      "field": "ano-referencia",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rendaModal.anoReferencia),
      expression: "rendaModal.anoReferencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        ("required|numeric|max_value:" + _vm.anoReferenciaAtual)
      ),
      expression: "\n                    `required|numeric|max_value:${anoReferenciaAtual}`\n                  "
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "203px"
    },
    attrs: {
      "type": "text",
      "name": "ano-referencia",
      "id": "ano-referencia",
      "data-vv-as": "Ano Ref."
    },
    domProps: {
      "value": (_vm.rendaModal.anoReferencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rendaModal, "anoReferencia", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "form-group col-xs-7 col-sm-4"
  }, [_c('label', [_vm._v("Ano Ref.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rendaModal.anoReferencia))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Renda Anual")]), _vm._v(" "), _c('money', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rendaModal",
      "id": "rendaModal"
    },
    model: {
      value: (_vm.rendaModal.valor),
      callback: function($$v) {
        _vm.$set(_vm.rendaModal, "valor", $$v)
      },
      expression: "rendaModal.valor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde-inline",
      "icone": "fa-plus fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.incluiRenda()
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "0 15px"
    }
  }, [(_vm.listaDeRendasModal.length === 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Não existe renda\n                  cadastrada.\n                ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rendasOrdenadasModal), function(cadaRenda) {
    return _c('tr', {
      key: cadaRenda.anoReferencia
    }, [_c('td', [_vm._v(_vm._s(cadaRenda.anoReferencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("monetarioMask")(cadaRenda.valor)))]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [_c('botao', {
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaRendaModal(cadaRenda)
        }
      }
    })], 1)])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancelaRenda()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Salvar Rendas",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaRenda()
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Parceiros Econômicos \n                "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreExplicacaoModal()
      }
    }
  }, [_vm._v("(Quem é considerado parceiro econômico?)")])])]), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.dependencias.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Não existem\n                    parceiros cadastrados.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-sm"
  }, [_vm._v("\n                          Grau de Parentesco\n                        ")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dependenciasOrdenadas), function(dependencia) {
    return _c('tr', {
      key: _vm.dependencias.indexOf(dependencia)
    }, [_c('td', [_vm._v(_vm._s(dependencia.dependente.nome))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("cpfMask")(dependencia.dependente.cpf)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-sm"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("grauParentescoFilter")(dependencia.grau)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Apagar'),
        expression: "'Apagar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.exclui(dependencia)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "tipo": "button",
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(dependencia)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde-dir",
      "rotulo": "Novo",
      "icone": "novo-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.novo()
      }
    }
  })], 1)])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n              Entenda o Paraceiro Econômico\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Parceiro econômico")]), _vm._v(" é aquele que participa\n                  economicamente dos bens declarados.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Importante:")]), _vm._v(" não se faz necessário cadastrar\n                  parceiros\n                  "), _c('strong', [_vm._v("sem CPF.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13472047","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dependente/index.vue
// module id = fm+M
// module chunks = 5